import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarStateService {
  sidebarState: Subject<any> = new Subject();

  constructor() {}

  sendSidebarStateUpdate(state: 'expand' | 'collapse' | 'compact') {
    this.sidebarState.next(state);
  }
}
